import angular from 'angular';

class principalDocumentarySpaceCtrl {
    /* @ngInject */
    constructor($state, logger, PrincipalSvc, AuthSvc, $uibModal, $translate) {
        this.$state = $state;
        this.logger = logger;
        this.PrincipalSvc = PrincipalSvc;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.$translate = $translate;
    }

    $onInit() {
        // initialisation de l'object documentary space
        this.initDocumentarySpace = angular.copy(this.documentarySpace);
        this.includes = {
            errorMessages: require('../layouts/error-messages.html'),
        };
    }

    //-----------------------
    // vérification et création de l'espace documentaire
    //-----------------------
    validate() {
        if (this.form.$valid) {
            this.PrincipalSvc.checkAndSaveDocumentarySpace(this.principal.detail.id, this.documentarySpace, true).then(
                () => {
                    this.logger.success('success.do_update');
                    this.$state.reload();
                },
                error => {
                    this.showResult(error);
                }
            );
        }
    }

    //-----------------------
    // mise à jour de l'espace documentaire
    //-----------------------
    update() {
        if (this.form.$valid) {
            this.PrincipalSvc.updateDocumentarySpace(this.principal.detail.id, this.documentarySpace).then(
                () => {
                    this.logger.success('success.do_update');
                    this.$state.reload();
                },
                error => {
                    this.showResult(error);
                }
            );
        }
    }

    //-----------------------
    // suppression de l'espace documentaire
    //-----------------------
    delete() {
        if (this.initDocumentarySpace.id != null) {
            this.PrincipalSvc.deleteDocumentarySpace(this.principal.detail.id, this.initDocumentarySpace).then(
                () => {
                    this.logger.success('success.do_update');
                    this.$state.reload();
                },
                error => {
                    this.showResult(error);
                }
            );
        }
    }

    showResult(checkResult) {
        if (
            [
                'DOCUMENTARY_SPACE_NOT_EXIST',
                'DOCUMENTARY_SPACE_EXIST_FOR_OTHER_PRINCIPAL',
            ].includes(checkResult.data.code)
        ) {
            this.showErrorModal('documentary_space.errors.'.concat(checkResult.data.code).toLowerCase());
        } else {
            this.logger.error('error.generic', checkResult);
        }
    }

    cancel() {
        this.documentarySpace = angular.copy(this.initDocumentarySpace);
    }

    // pré-remplir le champs Description quand le Label du type est renseigné
    changeDescriptionValue() {
        this.documentarySpace.description =
            this.principal.detail.corporateName + '- Base ' + document.getElementById('typeLabel').value;
    }

    /**
     * affiche le modal de confirmation de la création d'espace documentaire pour le DO
     * @param message message qui contient la liste des sociétés séparées par une virgule
     */
    showConfirmationModal(message) {
        var ctrl = this;
        var multiCompany = message.includes(',') ? 'companies' : 'company';
        var messageKey = 'documentary_space.modal.message.'.concat(multiCompany);
        var modalMessage = this.$translate.instant(messageKey, {
            param: message,
        });

        ctrl.$uibModal
            .open({
                component: 'confirmationModal',
                size: 'md',
                resolve: {
                    modalTitle: () => {
                        return { value: 'documentary_space.modal.title' };
                    },
                    modalMessage: () => {
                        return [{ key: modalMessage }];
                    },
                    modalCancelButtonText: () => {
                        return { value: 'commons.cancel' };
                    },
                    modalConfirmButtonText: () => {
                        return { value: 'commons.confirm' };
                    },
                    data: () => {
                        return null;
                    },
                },
                backdrop: 'static',
                keyboard: false,
            })
            .result.then(() => {
                this.PrincipalSvc.checkAndSaveDocumentarySpace(
                    this.principal.detail.id,
                    this.documentarySpace,
                    false
                ).then(
                    () => {
                        this.logger.success('success.do_update');
                        this.initDocumentarySpace = this.documentarySpace;
                    },
                    error => {
                        this.showResult(error);
                    }
                );
            }, {});
    }

    /**
     * affiche le modal d'erreur lié à l'enregistrement de l'espace documentire'
     * @param errorCode code lié à l'erreur
     */
    showErrorModal(errorCode) {
        var ctrl = this;
        ctrl.$uibModal
            .open({
                component: 'modalMessage',
                size: 'lg',
                resolve: {
                    modalTitle: () => {
                        return ctrl.$translate.instant('commons.error_registration');
                    },
                    message: () => {
                        return errorCode;
                    },
                },
            })
            .result.then({}, {});
    }

    hasDocumentarySpaceGroup() {
        return (
            this.initDocumentarySpace && this.initDocumentarySpace.group && this.initDocumentarySpace.group.length != 0
        );
    }
}

angular.module('app.principal').component('documentarySpace', {
    templateUrl: require('./principal-documentary-space.html'),
    controller: principalDocumentarySpaceCtrl,
    bindings: {
        principal: '<',
        documentarySpace: '<',
    },
});
